import React from "react";
import { Link } from "@quintype/components";
import { object } from "prop-types";
import { connect } from "react-redux";
import GoogleNews from "../google-news-icon";
import get from "lodash/get";
import Whatsapp from "../../atoms/social-media-icons/Whatsapp";

import "./follow-story-page.m.css";

function FollowUs({ socialLinks, socials, isPVExclusive }) {
  if (!socialLinks) {
    return null;
  }
  const whatsAppUrl = socials && socials.whatsapp ? socials.whatsapp.url : socialLinks["whatsapp-url"];
  const googleNewsUrl = socials && socials.googlenews ? socials.googlenews.url : socialLinks["google-news-url"];

  return (
    <div styleName={`follow-us-wrapper ${isPVExclusive ? "exclusive-follow-us" : ""}`}>
      <div>
        <button>
          <Link href={whatsAppUrl} target="_blank" styleName="whatsapp">
            <Whatsapp width="20" height="20" color="#25D366" />
          </Link>
        </button>
      </div>
      <div>
        <button>
          <Link href={googleNewsUrl} target="_blank" styleName="google-news">
            <GoogleNews width="40" height="40" />
          </Link>
        </button>
      </div>
    </div>
  );
}

FollowUs.propTypes = {
  socialLinks: object,
  socials: object
};

const mapStateToProps = (state) => ({
  socialLinks: get(state, ["qt", "config", "social-links"], {})
});

export default connect(mapStateToProps, null)(FollowUs);
